import React, { useEffect, useState } from 'react';
import { AddStoreModalWrapper } from './AddStoreModal.style';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import { useForm } from '../../molecules/Form';
import LocationIcon from '../../../assets/location.png';
import Button from '../../molecules/Button';
import ModalContainer from '../../molecules/ModalContainer';
import GoogleLocationSelector from '../GoogleLocationSelector';
import { generatePsscode } from '../../../helpers/common';
import storeService from '../../../services/storeService';
import Toast from '../../molecules/Toast';
import adminService from '../../../services/adminService';
import Select from '../../molecules/Select';

export const currencyData = [
  { label: 'United States Dollar', value: 'USD' },
  { label: 'Pakistani Rupee', value: 'PKR' },
  { label: 'Euro', value: 'EUR' },
  { label: 'British Pound Sterling', value: 'GBP' },
  { label: 'Japanese Yen', value: 'JPY' },
  { label: 'Australian Dollar', value: 'AUD' },
  { label: 'Canadian Dollar', value: 'CAD' },
  { label: 'Chinese Yuan', value: 'CNY' },
  { label: 'Indian Rupee', value: 'INR' },
  { label: 'Russian Ruble', value: 'RUB' },
  { label: 'Saudi Riyal', value: 'SAR' },
  { label: 'South African Rand', value: 'ZAR' },
  { label: 'United Arab Emirates Dirham', value: 'AED' },
  { label: 'Swiss Franc', value: 'CHF' },
  { label: 'Singapore Dollar', value: 'SGD' },
];

const AddStoreModal = ({ AddDeviceModal, onSubmit, setSubmission, data, refetch, isEdit }) => {
  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    pageSize: 10,
    searchText: '',
    startDate: '',
    endDate: '',
    filterRoles: '',
  });
  const [form] = useForm();
  const [location, setLocation] = useState('');

  const { admins_data } = adminService.GetAdmins(searchQuery);

  const { first_name, last_name, email } = data?.owner;
  const { _id } = data;
  const handelSubmit = async values => {
    const { passcode, storeLocation, storeName, currency, ...rest } = values;
    if (!isEdit) {
      const payload = {
        passcode: passcode.trim(),
        address: { value: storeLocation },
        title: storeName.trim(),
        business_id: _id,
        currency: currency?.value,
        ...rest,
      };
      try {
        await storeService.addStore(payload);
        onSubmit();
        Toast({
          type: 'success',
          message: 'Store added successfully',
        });
        refetch();
      } catch (error) {
        Toast({
          type: 'error',
          message: error.message,
        });
      }
    } else {
      const editPayload = {
        address: { value: storeLocation },
        title: storeName.trim(),
        report_print_time: values?.report_print_time,
      };
      try {
        await storeService.editStore({ _id: isEdit?._id, ...editPayload });
        onSubmit();
        refetch();
        Toast({
          type: 'success',
          message: 'Store Updated successfully',
        });
      } catch (error) {
        Toast({
          type: 'error',
          message: error.message,
        });
      }
    }
  };
  const onAutoPasscodeGenerate = () => {
    const autoGeneratedPasscode = generatePsscode(4);

    form.setFieldsValue({
      passcode: String(autoGeneratedPasscode),
    });
  };

  useEffect(() => {
    if (!isEdit) {
      const autoGeneratedPasscode = generatePsscode(4);

      form.setFieldsValue({
        passcode: String(autoGeneratedPasscode),
        report_print_time: '21:45:00',
        first_name: first_name,
        last_name: last_name,
        email: email,
      });
    } else {
      form.setFieldsValue({
        storeName: isEdit?.title,
        report_print_time: isEdit?.report_print_time,
        storeLocation: isEdit?.address?.value,
      });
    }
  }, [admins_data, form]);
  useEffect(() => {
    if (location !== '') {
      form.setFieldsValue({
        storeLocation: location?.formatted_address,
      });
    }
  }, [location, form]);

  return (
    <>
      <AddStoreModalWrapper>
        <Form form={form} onSubmit={handelSubmit}>
          <div className="input-wrap">
            <Form.Item
              noMargin
              type="text"
              name="storeName"
              sm
              rounded
              placeholder="Enter Name"
              label="Store Name"
              rules={[
                {
                  required: true,
                  message: 'Store Name is Required',
                },
              ]}>
              <Field maxLength={40} />
            </Form.Item>
            <ModalContainer
              width="711"
              title="Add Store Location"
              btnComponent={({ onClick }) => (
                <Form.Item
                  noMargin
                  type="text"
                  name="storeLocation"
                  sm
                  rounded
                  suffix={<img src={LocationIcon} alt="locationIcon" />}
                  placeholder="Enter Location"
                  label="Store Location"
                  onClick={onClick}
                  rules={[
                    {
                      required: true,
                      message: 'Location is Required',
                    },
                  ]}>
                  <Field maxLength={40} />
                </Form.Item>
              )}
              content={({ onClose }) => (
                <GoogleLocationSelector
                  selectedAddress={location}
                  value={location}
                  onSubmit={onClose}
                  open={true}
                  setCurrentAddress={value => setLocation(value)}
                />
              )}
            />
            {!isEdit && (
              <Form.Item
                sm
                type="passcode"
                label="Passcode"
                name="passcode"
                placeholder="Passcode"
                disabled
                onAutoPasscodeGenerate={onAutoPasscodeGenerate}
                rules={[
                  {
                    required: true,
                  },
                  { pattern: /^\d{4}$/, message: 'Minimum Digits length is 4' },
                ]}>
                <Field />
              </Form.Item>
            )}
            <Form.Item
              sm
              type="text"
              label="Auto print receipt time(00:00:01 - 23:59:59)"
              name="report_print_time"
              placeholder="HH:MM:SS"
              rules={[
                {
                  required: true,
                  message: 'auto print time is required',
                },
                {
                  pattern: /^(?:[01]?\d|2[0-3]):[0-5]\d:[0-5]\d$/,
                  message: 'Invalid time format. Please use HH:mm:ss (e.g. 05:10:00)',
                },
              ]}>
              <Field />
            </Form.Item>
          </div>
          {!isEdit && (
            <div className="input-wrap">
              <Form.Item
                sm
                type="text"
                label="Currency"
                name="currency"
                placeholder="Please Select Currency"
                options={currencyData}
                menuPosition="fixed"
                rules={[
                  {
                    required: true,
                    message: 'Currency is required',
                  },
                ]}>
                <Select />
              </Form.Item>
            </div>
          )}
          {!isEdit && (
            <>
              <strong className="form-subtitle">Owner Details</strong>
              <div className="input-wrap">
                <Form.Item
                  noMargin
                  type="text"
                  name="first_name"
                  sm
                  rounded
                  placeholder="Enter Owner's First Name"
                  label="Owner First Name"
                  rules={[
                    { required: true, message: 'Please enter owner first name' },
                    {
                      pattern: /^[a-zA-Z\s]+$/,
                      message: 'First name should be Alphabets.',
                    },
                    {
                      pattern: /^[a-zA-Z\s]{3,}$/,
                      message: 'Owner first name must be minimum of 3 characters.',
                    },
                    {
                      pattern: /^[a-zA-Z\s]{3,40}$/,
                      message: 'Owner first name should be maximum of 40 characters.',
                    },
                  ]}>
                  <Field maxLength={40} />
                </Form.Item>

                <Form.Item
                  noMargin
                  type="text"
                  name="last_name"
                  sm
                  rounded
                  placeholder="Enter Owner's Last Name"
                  label="Owner Last Name"
                  rules={[
                    { required: true, message: 'Please enter owner last name' },
                    {
                      pattern: /^[a-zA-Z\s]+$/,
                      message: 'Last name should be Alphabets.',
                    },
                    {
                      pattern: /^[a-zA-Z\s]{3,}$/,
                      message: 'Owner last name must be minimum of 3 characters.',
                    },
                    {
                      pattern: /^[a-zA-Z\s]{3,40}$/,
                      message: 'Owner last name should be maximum of 40 characters.',
                    },
                  ]}>
                  <Field maxLength={40} />
                </Form.Item>
                <Form.Item
                  type="text"
                  name="email"
                  sm
                  rounded
                  placeholder="Enter Email Address"
                  label="Owner Email"
                  rules={[
                    { required: true, message: 'Please enter owner email address.' },
                    { email: true, message: 'Please enter a valid owner email address.' },
                    { max: 40, message: 'Email should be at max 40 characters!' },
                  ]}>
                  <Field maxLength={40} />
                </Form.Item>
              </div>
            </>
          )}
          <Button width="163px">Add Store</Button>
        </Form>
      </AddStoreModalWrapper>
    </>
  );
};

export default AddStoreModal;
